* {
  --primary-color: #684ab1;
  --text-color: #424755;
  --background-color: #ededed;
  --font-width: 550;
  margin: 0pt;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.super {
  font-size: medium;
  font-weight: 500;
  color: var(--text-color);
}

.title {
  color: rgb(54, 54, 54);
  font-size: larger;
  margin-top: 5pt;
  margin-bottom: 5pt;
  font-weight: 550;
}

.body {
  color: rgb(75, 75, 75);
  font-size: large;
  margin-top: 5pt;
  margin-bottom: 5pt;
  font-weight: 450;
}
